/* Ürün detaydaki tarif karuseli.

   Tek kart görünür; noktalar, "Başka Tarif Öner" butonu ve dokunmatik
   kaydırma ile sıradaki tarife geçilir. */
(function () {
  'use strict';

  class KsRecipeCarousel extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-recipe-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-recipe-dot]'));
      this.pos = this.closest('.ks-precipe') && this.closest('.ks-precipe').querySelector('[data-recipe-pos]');
      this.index = 0;
      if (this.slides.length < 2) return;

      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-recipe-next]')) { this.step(1); return; }
        const dot = event.target.closest('[data-recipe-dot]');
        if (dot) this.show(Number(dot.dataset.recipeDot) - 1);
      });

      // Dokunmatik kaydırma.
      let sx = null;
      this.addEventListener('touchstart', (e) => { sx = e.changedTouches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', (e) => {
        if (sx === null) return;
        const dx = e.changedTouches[0].clientX - sx;
        if (Math.abs(dx) > 50) this.step(dx < 0 ? 1 : -1);
        sx = null;
      }, { passive: true });
    }

    step(delta) {
      this.show((this.index + delta + this.slides.length) % this.slides.length);
    }

    show(index) {
      this.index = index;
      this.slides.forEach((slide, i) => {
        const on = i === index;
        slide.hidden = !on;
        slide.classList.toggle('is-active', on);
      });
      this.dots.forEach((dot, i) => {
        const on = i === index;
        dot.classList.toggle('is-active', on);
        dot.setAttribute('aria-selected', String(on));
      });
      if (this.pos) this.pos.textContent = (index + 1) + ' / ' + this.slides.length;
    }
  }

  if (!customElements.get('ks-recipe-carousel')) customElements.define('ks-recipe-carousel', KsRecipeCarousel);
})();
